// client/src/pages/InviteMembers.js
import React, { useEffect, useState } from 'react';
import { apiFetch } from '../lib/api';
import { QRCodeCanvas } from 'qrcode.react';
import { useParams } from 'react-router-dom';
import logo from '../assets/chitconnect-logo-blue.png';
import '../App.css';

export default function InviteMembers() {
  const { groupId } = useParams();
  const [inviteUrl, setInviteUrl] = useState('');
  const [whatsappLink, setWhatsappLink] = useState('');
  const [error, setError] = useState('');
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    let isMounted = true;

    const generateInvite = async () => {
      if (!groupId) {
        setError('Missing groupId in URL.');
        return;
      }

      try {
        setError('');

        const res = await apiFetch(`/api/invitations/generate/${groupId}`);
        const text = await res.text();

        let data = {};
        try {
          data = text ? JSON.parse(text) : {};
        } catch (e) {
          console.error('Failed to parse invite JSON:', e, 'raw:', text);
          data = {};
        }

        if (!res.ok) {
          throw new Error(data.error || `HTTP ${res.status}`);
        }

        if (isMounted && data.inviteUrl) {
          setInviteUrl(data.inviteUrl);
          setWhatsappLink(
            `https://wa.me/?text=${encodeURIComponent(
              `You're invited to join our Chit Fund group! Tap to join: ${data.inviteUrl}`
            )}`
          );
        } else if (isMounted) {
          setError('Failed to generate invite link.');
        }
      } catch (err) {
        console.error('Failed to create invite:', err);
        if (isMounted) {
          setError(
            err.message === 'Failed to fetch'
              ? 'Network error while creating invite.'
              : 'Server error while creating invite.'
          );
        }
      }
    };

    generateInvite();

    return () => {
      isMounted = false;
    };
  }, [groupId]);

  const handleCopy = () => {
    if (!inviteUrl) return;
    navigator.clipboard.writeText(inviteUrl).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div className="main-content">
      <img src={logo} alt="ChitConnect Logo" className="group-logo" />
      <h2>Invite to Group</h2>

      {error && <p className="error-text">{error}</p>}

      {!error && !inviteUrl && <p>Generating invite link...</p>}

      {inviteUrl && (
        <div className="invite-card">
          <p>
            <strong>Invite Link:</strong>
          </p>
          <a href={inviteUrl} target="_blank" rel="noopener noreferrer">
            {inviteUrl}
          </a>

          {/* 📱 QR Code Display */}
          <div style={{ marginTop: '20px' }}>
            <p>
              <strong>Scan QR Code:</strong>
            </p>
            <QRCodeCanvas
              value={inviteUrl}
              size={160}
              bgColor="#ffffff"
              fgColor="#000000"
              level="H"
              includeMargin={true}
            />
          </div>

          <div className="invite-buttons">
            <button onClick={handleCopy}>
              📋 {copied ? 'Copied!' : 'Copy Link'}
            </button>
            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="whatsapp-invite-button"
            >
              📱 Share via WhatsApp
            </a>
          </div>
        </div>
      )}
    </div>
  );
}
